export const ERROR_MESSAGES = {
  JOIN_CODE_NOT_PROVIDED: 'Join code not provided',
  RESOLVE_JOIN_CODE_FAILED: 'Failed to resolve join code',
} as const;
